import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
// import Personnel from 'src/models/personnel/Personnel';
// import useFetch from 'use-http';
import _ from 'lodash';
import 'src/styles/pages/_accountsPayable.scss';
import ChargeIndividual from 'src/models/AP/ChargeIndividual';
import ClientLandman from 'src/models/ClientLandman';

interface IFindPersonDialogProps {
    dialogName: string;
    handleSelectedPerson?: (person: ChargeIndividual | ClientLandman) => void;
    hideDialog: () => void;
    populatePersonList: () => void;
    personList: Array<ChargeIndividual> | Array<ClientLandman>;
    setPersonSearchTerm?: (keyword: string) => void;
}

const FindPersonDialog = (props: IFindPersonDialogProps) => {
    const { register, errors, getValues } = useForm();
    const [selectedPerson, setSelectedPerson] = useState<ChargeIndividual | ClientLandman>(undefined);
    const [personnelSearchResults, setPersonnelSearchResults] = useState<Array<ChargeIndividual | ClientLandman>>(undefined); // The personnel filtered by search (Name)

    useEffect(() => {
        onCreate();
        props.populatePersonList();
    }, []);

    useEffect(() => {
        setPersonnelSearchResults(props.personList);
    }, [props.personList]);

    useEffect(() => {
        if (personnelSearchResults) {
            console.log('PersonnelSearchResults Updated', personnelSearchResults);
        }
    }, [personnelSearchResults]);

    const onCreate = () => {
        // getPersonnel();
        console.log('FindPersonDialog onCreate()');
    };

    const OKClicked = () => {
        props.handleSelectedPerson(selectedPerson);
        props.hideDialog();
    };

    const search = _.debounce(() => {
        let searchName = getValues()?.search;
        props.setPersonSearchTerm(searchName);
    }, 800);

    /**
     * Gets the list of Personnel Users and stores in personnelList
     */
/*     const getPersonnel = async () => {
        let result = await get(`/v1.0/landmen`);
        if (response.ok && result) {
            setPersonnelList(result.items);
            setPersonnelSearchResults(result.items);
        } else {
            console.log('Unable to get the Personnel Data!!! >:c');
        }
    }; */

    return (
        <Dialog title="Find Person" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '55%' }}>
            <div className="form-row" style={{marginTop: '1rem'}}>
                <RHFInputBox labelOnLeft={true} label="Last Name" name={'search'} register={register} errors={errors} style={{width: '70%'}} onChange={() => search()}/>
                <RHFSelect 
                    name={`display`}
                    placeholder="Display Type"
                    options={[
                        { value: 'all', label: 'All' },
                        { value: 'active', label: 'Active' },
                        { value: 'inactive', label: 'Inactive' },
                    ]}
                    style={{width: '100%', border: '.5px solid LightGray', borderRadius: '5px'}}
                    // onChange={() => filter()}
                    bodyStyle={{width: '18%', marginLeft: '2rem'}}
                    register={register} 
                    errors={errors}
                />
            </div>
            <div style={{marginTop: '3rem', overflowY: 'scroll', height: '20rem'}}>
                <form>
                    <table>
                        <thead style={{ textAlign: 'center' }}>
                            <tr>
                                <th className="find-person-header" style={{ width: '12%' }}>Last Name</th>
                                <th className="find-person-header" style={{ width: '12%' }}>First Name</th>
                                <th className="find-person-header" style={{ width: '6%' }}>LM #</th>
                                <th className="find-person-header" style={{ width: '5%' }}>CL #</th>
                                <th className="find-person-header" style={{ width: '25%' }}>Client or Company Name</th>
                                <th className="find-person-header" style={{ width: '19%' }}>City</th>
                                <th className="find-person-header" style={{ width: '5%' }}>State</th>
                                <th className="find-person-header" style={{ width: '14%' }}>Type</th>
                            </tr>
                        </thead>
                        {personnelSearchResults?.map((person: ChargeIndividual | ClientLandman, index: number) => {
                            return (
                                <tbody key={person.id}>
                                    <tr 
                                        className="table-item-hover" 
                                        style={person?.id === selectedPerson?.id ? { background: 'yellow', textAlign: 'left' } : { textAlign: 'left' }} 
                                        onClick={() => setSelectedPerson(person)}
                                    >
                                        <td style={{ width: '12%' }}>
                                            <label>{person?.lastName}</label>
                                        </td>
                                        <td style={{ width: '12%' }}>
                                            <label>{person?.firstName}</label>
                                        </td>
                                        <td style={{ width: '6%' }}>
                                            <label>{(person instanceof ChargeIndividual) ? (person as ChargeIndividual)?.lmNo : person?.number}</label>
-                                       </td>
-                                       <td style={{ width: '25%' }}>
-                                           <label>{person?.clientNumber}</label>
                                        </td>
                                        <td style={{ width: '25%' }}>
                                            <label>{person?.clientName}</label>
                                        </td>
                                        <td style={{ width: '19%' }}>
                                            <label>{person?.clientCity}</label>
                                            {/* <RHFInputBox
                                                name={`personnelList[${index}].corporationAddress.city`}
                                                type="text"
                                                defaultVal={person?.corporationAddress?.city}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            /> */}
                                        </td>
                                        <td style={{ width: '5%' }}>
                                            <label>{person?.clientState}</label>
                                            {/* <RHFInputBox
                                                name={`personnelList[${index}].corporationAddress.state.abbreviation`}
                                                type="text"
                                                defaultVal={person?.corporationAddress?.state?.abbreviation}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            /> */}
                                        </td>
                                        <td style={{ width: '7%' }}>
                                            <label>{'Active'}</label>
                                            {/* <RHFInputBox
                                                name={`personnelList[${index}].status`}
                                                type="text"
                                                defaultVal={person?.personType}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            /> */}
                                        </td>
                                        <td style={{ width: '7' }}>
                                            <label>{(person instanceof ChargeIndividual) ? person?.personType : person?.status}</label>
                                            {/* <RHFInputBox
                                                name={`personnelList[${index}].type`}
                                                type="text"
                                                defaultVal={person?.personType}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            /> */}
                                        </td>
                                    </tr>
                                </tbody>
                                );
                            })}
                    </table>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '12%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '12%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '12%', marginRight: '1rem' }}
                    text={'Add Other'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default FindPersonDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/FindPersonDialog.tsx